import React from 'react';
import { DownloadIcon, PartyPopperIcon, PrinterIcon } from 'lucide-react';
type SummaryItem = {
  label: string;
  icon: React.ReactNode;
};
const summaryItems: SummaryItem[] = [{
  label: '30 juegos imprimibles',
  icon: <PrinterIcon className="h-4 w-4 text-[#E74D7A]" strokeWidth={1.75} aria-hidden="true" data-id="element-369" data-mp="1sya13iy1l1ht" />
}, {
  label: '50 dinámicas divertidas',
  icon: <PartyPopperIcon className="h-4 w-4 text-[#15ADA8]" strokeWidth={1.75} aria-hidden="true" data-id="element-370" data-mp="118eyikl6bfb7" />
}, {
  label: 'Versiones rosa y celeste',
  icon: <span className="flex gap-0.5" aria-hidden="true" data-id="element-371" data-mp="wavlfo07p8ku">
        <span className="h-2.5 w-2.5 rounded-full bg-[#F5B4C9]" data-id="element-372" data-mp="1a0gzql32gzmj" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#93D1CE]" data-id="element-373" data-mp="1a2topi78sa93" />
      </span>
}, {
  label: 'Descarga digital',
  icon: <DownloadIcon className="h-4 w-4 text-[#9A7A60]" strokeWidth={1.75} aria-hidden="true" data-id="element-374" data-mp="hk68ag36xjec" />
}];
export function StatsGrid() {
  return <section aria-label="Qué incluye Baby Shower Dulce Recuerdo" className="border-y border-[#EFE4D6] bg-[#F7EFE4] py-4 md:py-5" style={{
    paddingTop: "11px"
  }} data-id="element-375" data-mp="dib7rdt33a1m">
      <ul className="mx-auto grid max-w-4xl grid-cols-2 gap-2 px-4 md:grid-cols-4 md:gap-3 md:px-5" data-id="element-376" data-mp="229072qgbwb4s">
        {summaryItems.map(item => <li key={item.label} className="flex items-center gap-2.5 rounded-2xl bg-white/80 px-3 py-2.5 md:justify-center md:px-4" data-id="element-377" data-mp="271jm7runzebp">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#FBF6EE]" data-id="element-378" data-mp="2c1e9zmj57nsj">{item.icon}</span>
            <span className="text-[13px] font-semibold leading-tight text-[#4A3A35] sm:text-[14px]" data-id="element-379" data-mp="1jae6rdsmyo1x">{item.label}</span>
          </li>)}
      </ul>
    </section>;
}